import { render } from "./guide-articlecontent.vue?vue&type=template&id=40c73f1a"
import script from "./guide-articlecontent.js?vue&type=script&lang=js"
export * from "./guide-articlecontent.js?vue&type=script&lang=js"

import "./guide-articlecontent.vue?vue&type=style&index=0&id=40c73f1a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__